import { Menu } from 'antd';
import { FC } from 'react';

export interface BVMenuItemProps {
	onClick: () => void;
	icon: React.ReactNode;
	title: string;
}

export const BVMenuItem: FC<BVMenuItemProps> = ({ onClick, icon, title }) => {
	return (
		<Menu.Item
			key={title}
			className="bv-sidebar-nav-item"
			icon={icon}
			title={title}
			onClick={onClick}
		>
			{title}
		</Menu.Item>
	);
};
